enum ButtonPosition {
  Left = 'left',
  Center = 'center',
  Right = 'right',
}

export default ButtonPosition;
